import classNames from "classnames";
import { FC, ReactNode } from "react";
import styles from "./index.module.scss";

interface ContentContainerProps {
  title: string;
  children: ReactNode;
  belowTitle?: ReactNode;
  success?: boolean;
  className?: string;
}

const ContentContainer: FC<ContentContainerProps> = ({
  title,
  children,
  belowTitle,
  success = false,
  className,
}) => {
  return (
    <div className={classNames(styles.container, className)}>
      <span className={classNames("h4", styles.title, success && styles.successTitle)}>
        {title}
      </span>
      {belowTitle && belowTitle}
      <div className={styles.separator} />
      {children}
    </div>
  );
};

export default ContentContainer;
